import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '432px',
      height: '300px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      background: '#FFFFFF',
      boxShadow: '0px 4px 4px #00000040',
      outline: `2px dashed #B1B1B1`,
      borderRadius: '4px',
      position: 'absolute',
      zIndex: 10,
    },

    titleContainer: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.085)',
      order: 1,
    },

    title: {
      marginLeft: '16px',
    },

    textContainerWithDetails: {
      margin: '16px',
      order: 2,
    },

    textContainerSuccess: {
      margin: '64px',
      order: 2,
    },

    downloadTextContainer: {
      marginTop: '16px',
      paddingLeft: '54px',
    },

    buttons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      margin: '0',
      paddingRight: '16px',
      paddingBottom: '16px',
      order: 3,
      marginTop: '13px',
    },
  },
  {
    name: 'FileResultModal',
  },
);
